import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TechnicalWorksService {

  private _isTechnicalWorksMode = false;
  private technicalWorksMode$$: Subject<boolean> = new Subject();
  public get isTechnicalWorksMode() {
    return this._isTechnicalWorksMode;
  }
  public set isTechnicalWorksMode(value: boolean) {
    this._isTechnicalWorksMode = value;
    this.technicalWorksMode$$.next(value);
  }
  public get technicalWorksMode$(): Observable<boolean> {
    return this.technicalWorksMode$$.asObservable();
  }

  private _isBlockingLoaderMode = false;
  private blockingLoaderMode$$: Subject<boolean> = new Subject();
  public get isBlockingLoaderMode() {
    return this._isBlockingLoaderMode;
  }
  public set isBlockingLoaderMode(value: boolean) {
    this._isBlockingLoaderMode = value;
    this.blockingLoaderMode$$.next(value);
  }
  public get blockingLoaderMode$(): Observable<boolean> {
    return this.blockingLoaderMode$$.asObservable();
  }

  private _blockingLoaderProgress: number = null;
  private blockingLoaderProgress$$: Subject<number> = new Subject();
  public get blockingLoaderProgress() {
    return this._blockingLoaderProgress;
  }
  public set blockingLoaderProgress(value: number) {
    this._blockingLoaderProgress = value;
    this.blockingLoaderProgress$$.next(value);
  }
  public get blockingLoaderProgress$(): Observable<number> {
    return this.blockingLoaderProgress$$.asObservable();
  }

  constructor() { }
}
